export const getBrowseAndSearchItemIds = (products = []) => {
  return products.map(({ itemId }) => itemId);
};

// Leftovers from LayoutManager deprecation. Should be retired if/when possible.
export const shouldDisplayResultsAppliedInner = (ctx = {}) => {
  return ctx?.isDynamicBrandPage;
};

export const shouldDisplayResultsAppliedOuter = (ctx = {}) => {
  return !ctx?.isDynamicBrandPage;
};

export const shouldDisplayTextAnExpert = (ctx = {}) => {
  return ctx?.isConsumerApp;
};
